"use client";
import React from "react";
import { HomeSectionContainerProps } from "./types";

const HomeSectionContainer: React.FC<HomeSectionContainerProps> = ({
  children,
  fullWidth,
}) => {
  return (
    <div
      className={`
      ${
        fullWidth
          ? "flex flex-col md:flex-row justify-center items-center gap-[20px] md:gap-[40px] lg:gap-[80px] p-8 md:p-16 overflow-hidden w-full"
          : "flex flex-col md:flex-row justify-between items-center gap-[20px] md:gap-[40px] lg:gap-[80px] p-8 md:p-16 overflow-hidden"
      }
    `}
    >
      {children}
    </div>
  );
};

export default HomeSectionContainer;
